// extracted by mini-css-extract-plugin
export var activityContainer = "_k0-0";
export var typingIndicatorContainer = "_k0-1";
export var typingIndicatorDot = "_k0-2";
export var wave = "_k0-3";